import { formatNumber } from "../../../helpers/number/numberFormat"
import React, { useEffect, useState } from 'react'
import theme from "../../theme"
import { Box } from '../Box'
import { LoadComponent, Text } from '../'
import { NextButton } from "../Button"
import { Icon } from "../Icon"
import { Image } from "../Image"
import { openCompanyTab } from '../../../helpers/cretool-extjs/Tabs'
import api from "../../../services/api";
import '../css/scroll.css'
import { useApp } from '../../../contexts';
import { getCoinCountryLabel, translateText } from '../../../helpers/util';

export const OfficeTransactionGrid = ({ officeId, vmvi }) => {
    const [transactions, setTransactions] = useState([])
    const [load, setLoad] = useState(false)
    const { language, translations, userCountry, buildingCountry } = useApp();
    
    useEffect(() => {
        setLoad(true)
        api.get(`/office/${officeId}/lasttransactions`).then(response => {
            const { transactions } = response.data;
            setTransactions(transactions)
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            setLoad(false)
        })

    }, []);

    const handleClickLogoCompany = (transaction) => {
        transaction.id_contato = transaction.id_ocupante_crm;
        transaction.nome_contato = "";
        openCompanyTab(transaction);
    }

    return (
        <LoadComponent isLoading={load}>
            <Box sx={{ flexDirection: 'row', display: 'flex', marginBottom: 1 }} >
                <div style={{ flex: 1, ...styles.transactionGridHeader, textAlign: "left", }}>
                    {translateText("Últimas Transações", language, translations, userCountry)}
                </div>
                <div style={{ width: 120, ...styles.transactionGridHeader }}>{translateText("Valor Nominal", language, translations, userCountry)} ({getCoinCountryLabel(buildingCountry)})</div>
                <div style={{ width: 120, ...styles.transactionGridHeader }}>{translateText("Valor", language, translations, userCountry)} ({getCoinCountryLabel(buildingCountry)} /m²)</div>
                <div style={{ width: 120, ...styles.transactionGridHeader }}>CAP Rate (%)</div>
            </Box>
            <div className="scroll" style={{ height: "100%" }}>
                {
                    transactions.map((transaction, index) => {
                        return (
                            <Box sx={{ flexDirection: 'row', display: 'flex', marginBottom: 1 }} key={`transaction-${index}`}>
                                <div style={{ flex: 1, ...styles.transactionGridColumn }}>
                                    <div style={{ flexDirection: 'row', display: 'flex' }}>
                                        <div style={{ width: 80, height: 60, display: 'flex', alignItems: "center", justifyContent: "center", cursor: 'pointer', overflow: 'hidden' }} onClick={() => handleClickLogoCompany(transaction)}>
                                            {transaction.url_logotipo !== null && (
                                                <Image url={transaction.url_logotipo} width={225} height={130} style={{ objectFit: 'contain' }} />
                                            )}
                                        </div>
                                        <div style={{ flexDirection: 'column', display: 'flex', margin: 5 }}>
                                            <Text style={styles.transactionGridColumnTextValue}>{transaction.tipo_locacao + " - " + transaction.trimestre + "T " + transaction.ano}</Text>
                                            <Text style={styles.transactionGridColumnSubTextValue}>{formatNumber(transaction.area_transacao)}m²</Text>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: 120, ...styles.transactionGridColumn, ...styles.textAlignCenter }}>
                                    <Text style={styles.transactionGridColumnTextValue}>
                                        {formatNumber(transaction.valor_nominal, 2)}
                                    </Text>
                                </div>
                                <div style={{ width: 120, ...styles.transactionGridColumn, ...styles.textAlignCenter }}>
                                    <Text style={styles.transactionGridColumnTextValue}>
                                        {formatNumber(transaction.valor_nominal / transaction.area_transacao, 2)}
                                    </Text>
                                </div>
                                <div style={{ width: 120, ...styles.transactionGridColumn, ...styles.textAlignCenter }}>
                                    <Text style={styles.transactionGridColumnTextValue}>
                                        {formatNumber(((transaction.valor_nominal / transaction.area_transacao) / vmvi) * 100 * 12, 2)}
                                    </Text>
                                </div>
                            </Box>
                        )
                    }
                    )
                }
            </div>
            {/* <div style={{ display: 'flex', flexDirection: 'column' }}>
            </div> */}
        </LoadComponent>
    )
}

const styles = {
    textAlignCenter: {
        textAlign: "center"
    },
    textAlignLeft: {
        textAlign: "left"
    },
    transactionGridHeader: {
        textAlign: "center",
        fontWeight: "600",
        fontSize: 13,
        color: "#7A7B7C"
    },
    transactionGridColumnTextValue: {
        color: "#000",
        fontWeight: "600",
        fontSize: 16
    },
    transactionGridColumnSubTextValue: {
        fontWeight: "600",
        fontSize: 13,
        color: "#464648"
    }
}